/**
 * Зарезервированные слаги CMS-страниц, которыми админ переопределяет тексты
 * модуля `Info` (SKUBY-CMS-MODULE-SPEC.md §10.3, роадмап MR 12a).
 *
 * Страницы витрины остаются по своим адресам (`/offer`, `/privacy`, …) — на них
 * ссылаются чекаут, регистрация и футер, поэтому URL не меняются, а явных FK
 * на канале не заводим (решение §10.3). Каждая страница сначала ищет материал
 * CMS с этим слагом; если админ его не завёл — показывается встроенный текст
 * шаблона, то есть витрина не остаётся без оферты и политики.
 */
export const infoCmsSlugs = {
  publicOffer: 'offer',
  privacyPolicy: 'privacy',
  personalDataConsent: 'agreement',
  returnsPolicy: 'returns',
  dataTransferConsent: 'data-transfer',
  about: 'about',
  faq: 'faq',
} as const

export type InfoCmsSlug = (typeof infoCmsSlugs)[keyof typeof infoCmsSlugs]
